export default "__VITE_ASSET__CSRiqpBg__"